import { render, staticRenderFns } from "./ImportContactsReports.vue?vue&type=template&id=1678c486&scoped=true&lang=pug"
import script from "./ImportContactsReports.vue?vue&type=script&lang=js"
export * from "./ImportContactsReports.vue?vue&type=script&lang=js"
import style0 from "./ImportContactsReports.vue?vue&type=style&index=0&id=1678c486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678c486",
  null
  
)

export default component.exports